/* Initialize the shared vehicle source before deferred consumers. */
(() => {
  const bridge = window.TWGFitmentPreview;
  if (bridge && !bridge.status().enabled) bridge.configureApp();
})();
